import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripUrl',
  standalone: true
})
export class StripUrlPipe implements PipeTransform {

  transform(url: string | null): string | null {
    if (!url) return '';
    return url.replace(/https?:\/\//, '');
  }

}
